import { render, staticRenderFns } from "./IntroductionLawyerViewPage.vue?vue&type=template&id=a646955e&scoped=true&"
import script from "./IntroductionLawyerViewPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionLawyerViewPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionLawyerViewPage.vue?vue&type=style&index=0&id=a646955e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a646955e",
  null
  
)

export default component.exports